
import React, {PropsWithChildren} from 'react';
import classnames from 'classnames';
import {isEmpty} from 'lodash';

import {ACUD_PRO_PREFIX} from '../../_common/constants';
import BottomSubmit, {BottomSubmitOptions} from '../BottomSubmit';

import Header, {HeaderInterface} from './Header';
import Desc, {DescInterface} from './Desc';
import Content, {ContentInterface} from './Content';

import './index.less';

export const PAGE_LAYOUT_PREFIX_CLS = `${ACUD_PRO_PREFIX}-page-layout`;

interface PageLayoutProps {
    className?: string;
    children: React.ReactNode;
    empty?: boolean;
    style?: React.CSSProperties;
    submitOptions?: BottomSubmitOptions[];
}
export interface PageLayoutInterface extends React.FC<PropsWithChildren<PageLayoutProps>> {
    Header: HeaderInterface;
    Desc: DescInterface;
    Content: ContentInterface;
}

const PageLayout: PageLayoutInterface = props => {
    const {className, children, empty, style, submitOptions} = props;

    const layoutCls = classnames(
        PAGE_LAYOUT_PREFIX_CLS,
        {[`${PAGE_LAYOUT_PREFIX_CLS}__empty`]: empty},
        className
    );

    return (
        <div className={layoutCls} style={style}>
            <div className={`${PAGE_LAYOUT_PREFIX_CLS}__main`}>
                {children}
            </div>
            {!isEmpty(submitOptions) && !empty && (
                <div className={`${PAGE_LAYOUT_PREFIX_CLS}__bottom`}>
                    <BottomSubmit options={submitOptions} />
                </div>
            )}
        </div>
    );
};

PageLayout.Header = Header;
PageLayout.Desc = Desc;
PageLayout.Content = Content;

export default PageLayout;